<template>
  <v-dialog v-model="dialogManageCompany" persistent max-width="700px">
      <template v-slot:activator="{}">
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">จัดการบริษัทในเครือ</span>
        </v-card-title>
        <v-card-text>
          <v-container>
              <TableManageCompany/>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogManageCompany = false">ยกเลิก</v-btn>
          <v-btn color="blue darken-1" text @click="dialogManageCompany = false">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from '@/EventBus'
import TableManageCompany from './_tableManageCompany'
export default {
  components: {
    TableManageCompany
  },
  data () {
    return {
      dialogManageCompany: false,
      textTitle: '',
      preName: ''
    }
  },
  mounted () {
    EventBus.$on('opendialogmanagecompany', this.openDialogManageCompany)
  },
  methods: {
    editCompany (value) {
      this.textTitle = ''
      // this.dialogCreate = true
      this.textTitle = value
    },
    openDialogManageCompany (value) {
      // console.log('Dialog Manage Company 2')
      this.dialogManageCompany = value
    },
    closeDialogCreate () {
      this.dialogCreate = false
      EventBus.$emit('closedialogcreate', this.dialogCreate)
    },
    submitEdit (preName) {
      this.dialogCreate = false
      this.preName = ''
    }
  }
}
</script>
<style scoped>
.txt-font {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
</style>
